import { z } from 'zod'

/** Represents the enum public.forecast_request_status_ */
enum ForecastRequestStatus {
  open = 'open',
  fulfilled = 'fulfilled',
  declined = 'declined',
  cancelled = 'cancelled',
  approved = 'approved',
}

export default ForecastRequestStatus

/** Zod schema for forecast_request_status_ */
export const forecastRequestStatus = z.enum([
  'open',
  'fulfilled',
  'declined',
  'cancelled',
  'approved',
])
